/*
  Storage of sorting, pagination and filtering
 */
export default {
  state: {
    reportPaginationSort: {
      groupBy: [],
      groupDesc: [],
      itemsPerPage: 50,
      mustSort: false,
      multiSort: false,
      page: 1,
      sortBy: [],
      sortDesc: []
    },
    reportFilter: {
      search: '',
      datePickerStart: null,
      datePickerEnd: null,
      timePickerStart: null,
      timePickerEnd: null
    }
  },
  mutations: {
    SET_REPORT_PAGINATION_SORT (state, payload) {
      state.reportPaginationSort = payload
    },
    SET_REPORT_FILTER (state, payload) {
      state.reportFilter = payload
    }
  },
  actions: {
    reportPaginationSort ({ commit }, payload) {
      commit('SET_REPORT_PAGINATION_SORT', payload)
    },
    reportFilter ({ commit }, payload) {
      commit('SET_REPORT_FILTER', payload)
    }
  }
}
